export const DOMAIN = process.env.REACT_APP_DOMAIN;
export const IMG_URL = process.env.REACT_APP_IMG_URL;
export const FILE_URL = process.env.REACT_APP_FILE_URL;
export const DOMAIN_API = process.env.REACT_APP_DOMAIN_API;
export const SSRDOMAIN = process.env.REACT_APP_SSRDOMAIN;
export const SSRQUERY=process.env.REACT_APP_SSRQUERY;